import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { getSettingSelectors } from '../../modules/settings/settings-general/store/setting.selector';
import { ISettingState } from '../../modules/settings/settings-general/store/setting.state';
import { IframeCapitalComponent } from '../iframe-capital/iframe-capital.component';
import { getCookie } from 'src/app/utils/get-cookie';
import { setSettingAction } from 'src/app/modules/settings/settings-general/store/setting.action';
import { Location } from '@angular/common';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  wealthName: string = '';
  clientName: string = '';
  currentUrl: string = '/';

  dataStoreSetting$: Observable<any>;
  dataStoreSetting: ISettingState;

  constructor(
    public dialog: MatDialog,
    private store: Store,
    private location: Location
  ) {
    this.location.onUrlChange((url) => (this.currentUrl = url));

    this.wealthName = getCookie('wealthName');
    this.clientName = getCookie('clientName');
  }

  ngOnInit() {
    this.getState();
    this.loadingNames();
  }

  loadingNames() {
    if (this.clientName !== '' && this.wealthName !== '') {
      this.dataStoreSetting.clientName = this.clientName;
      this.dataStoreSetting.consultantName = this.wealthName;
      this.setState(this.dataStoreSetting);
    }
  }

  openDialogInvestments() {
    const dialogRef = this.dialog.open(IframeCapitalComponent);
    dialogRef.afterClosed().subscribe();
  }

  getState() {
    this.dataStoreSetting$ = this.store.select(getSettingSelectors);
    this.dataStoreSetting$.subscribe((value) => {
      this.dataStoreSetting = {
        ...(this.dataStoreSetting = value),
      };
    });
  }

  setState(data: ISettingState) {
    this.store.dispatch(setSettingAction(data));
  }

  shouldHideHeader(): boolean {
    const url = this.currentUrl;
    return (
      url === '/' ||
      url === '/home' ||
      url === '/recomendation' ||
      url === '/inicio/clientes' ||
      url === '/inicio/estudo-pessoal' ||
      /^\/inicio\/clientes\/[^\/]+\/estudos$/.test(url)
    );
  }
}
